import { useCampaignSipTrunkCreateControllerCampaignCreateMutation } from '@shared/services/apiService/apiService';
import { ResponseMsg } from '@shared/types/admin/agent';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { CampaignSipTrunkValue } from '../model/type';
import { SipTruncFieldsError } from '@shared/types/admin/campaign';
import { campaignSipTrunkCreateRequestMapper } from '../utils/campaign-sip-trunk-mapper';

interface UseEditCampaignSipTrunkProps {
  setSipTrunkCreateFieldError: React.Dispatch<React.SetStateAction<SipTruncFieldsError>>;
  onSuccess?: () => void;
  onError?: () => void;
}

export const useEditCampaignSipTrunk = ({
  setSipTrunkCreateFieldError,
  onSuccess,
  onError,
}: UseEditCampaignSipTrunkProps) => {
  const [postSipTrunk] = useCampaignSipTrunkCreateControllerCampaignCreateMutation();
  const [responseMsg, setResponseMsg] = useState<ResponseMsg>({ message: '', type: 'success' });
  const [responseLoadingFlag, setResponseLoadingFlag] = useState(false);

  const formMethods = useForm<CampaignSipTrunkValue>({
    mode: 'all',
    defaultValues: {
      campaignId: '',
    },
  });

  const handleResponseMessage = (message: string, type: 'success' | 'error') => {
    if (type === 'error') {
      onError?.();
    } else if (type === 'success') {
      onSuccess?.();
    }
    setResponseMsg({ message, type });
  };

  const onSubmit = formMethods.handleSubmit(
    async (data) => {
      setResponseLoadingFlag(true);
      setResponseMsg({ message: '', type: 'success' });

      try {
        const campaignSipTrunkCreateRequestDto = campaignSipTrunkCreateRequestMapper(data);

        await postSipTrunk({
          id: data.campaignId,
          campaignSipTrunkCreateRequestDto,
        }).unwrap();

        handleResponseMessage('adminMainPage.campaigns.successfullyEdited', 'success');
      } catch (error) {
        setSipTrunkCreateFieldError((prevState) => ({
          ...prevState,
          editErrorMessage: (error as any).error,
        }));
        handleResponseMessage('adminMainPage.campaigns.somethingWentWrong', 'error');
      } finally {
        setResponseLoadingFlag(false);
      }
    },

    async () => {
      setResponseLoadingFlag(true);
      const data = formMethods.getValues();
      const campaignSipTrunkCreateRequestDto = campaignSipTrunkCreateRequestMapper(data);

      await postSipTrunk({
        id: data.campaignId,
        campaignSipTrunkCreateRequestDto,
      }).unwrap();

      setResponseLoadingFlag(false);
    },
  );

  return {
    onSubmit,
    setResponseMsg,
    responseMsg,
    responseLoadingFlag,
    formMethods,
  };
};
